import { jsx as _jsx } from "react/jsx-runtime";
import _slicedToArray from "/home/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import DesktopModal from './desktop-modal';
import { useTheme, useMediaQuery } from '@chakra-ui/react';
import MobileModal from './mobile-modal';
export function Modal(props) {
  var _theme$breakpoints;

  var isOpen = props.isOpen,
      onClose = props.onClose,
      children = props.children;
  var theme = useTheme();

  var _useMediaQuery = useMediaQuery("(max-width: ".concat(((_theme$breakpoints = theme.breakpoints) === null || _theme$breakpoints === void 0 ? void 0 : _theme$breakpoints.sm) || '470px', ")")),
      _useMediaQuery2 = _slicedToArray(_useMediaQuery, 1),
      isSmallScreen = _useMediaQuery2[0];

  if (isSmallScreen) return /*#__PURE__*/_jsx(MobileModal, {
    isOpen: isOpen,
    onClose: onClose,
    children: children
  });
  return /*#__PURE__*/_jsx(DesktopModal, {
    isOpen: isOpen,
    onClose: onClose,
    children: children
  });
}